module.exports = __webpack_public_path__ + "img/logo_light_gray.be536fbc.svg";